import React from 'react';
import { ReactComponent as Isotype } from '../images/isotipo.svg';

/**
 * Full logo component: includes isotype (SVG) and logotype text, aligned horizontally.
 * Uses currentColor for SVG fill, so color can be controlled via CSS.
 *
 * Props:
 * - size: Number, sets height of isotype in px (default 44)
 * - text: String, logotype text (default 'Social Media')
 * - className: String, for extra classes
 * - style: Object, for custom styles
 * - textStyle: Object, for custom text styles
 * - ...rest: Any other props for the wrapper
 */
export default function Logo({
                               size = 44,
                               text = 'Social Media',
                               className = '',
                               style = {},
                               textStyle = {},
                               ...rest
                             }) {
  // Adjust text font size to be better proportioned to the icon
  const textFontSize = size * 0.55; // Example: 44*0.55 = 24.2px

  return (
    <span
      className={`logo-combo d-flex align-items-center ${className}`}
      style={{ ...style, lineHeight: 1, textDecoration: 'none', color: 'inherit' }}
      {...rest}
    >
      <span className="logo-isotype d-flex align-items-center" style={{ height: size }}>
        <Isotype
          className="logo-svg"
          style={{
            width: size,
            height: size,
            fill: 'currentColor',
            display: 'block',
            transition: 'fill 0.18s',
          }}
        />
      </span>
      <span
        className="logo-text ms-2"
        style={{
          fontWeight: 700,
          fontSize: textFontSize,
          letterSpacing: 0.5,
          fontFamily: 'var(--font-family, Roboto, sans-serif)',
          color: 'inherit',
          marginLeft: 0.7 * size / 2,
          ...textStyle,
        }}
      >
        {text}
      </span>
    </span>
  );
}
